import AddEmail from 'components/Main/Emails/AddEmail/AddEmail'
import useFetch from 'elements/Hooks/useFetch'
import { get } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'

AddEmailCont.propTypes = {}

function AddEmailCont(props) {
  const key = get(props.match, 'params.key')

  const { data: email, fetching, fetch } = useFetch({
    url: `/emails/${key}`,
    dependencyArray: key,
  })

  return (
    <AddEmail
      {...{
        email,
        fetching,
        fetch,
      }}
    />
  )
}

export default withRouter(AddEmailCont)
